import React from 'react';
import "./About.css";

const About = () => {
    return (
        <section className="about">
            <h1 className="firm-name">ABOUT J-TEK LAW PLLC</h1>
            <div className="container">

                <hr className="style" />

                <div className="row">
                    <div className="col-sm">
                        <img className="logo-image" src="/jtek-logo.jpg" alt="group" />
                    </div>
                    <div className="col-sm">
                        <p>
                            J-TEK LAW PLLC is committed to providing the highest quality intellectual property legal services for the procurement and enforcement of U.S. and foreign rights. Our managing director, Jeffrey Tekanic, has acquired a comprehensive knowledge of U.S., European and Japanese intellectual property law and practice through his years of experience practicing around the world. Director Scott Wakeman has practiced intellectual property law in the U.S. for over 20 years and has worked extensively with U.S. and foreign clients. With this international experience, we can develop efficient and effective strategies for maximizing the value of your intellectual property rights in all major world markets.
                        </p>
                        <p>
                            J-TEK LAW PLLC is located in Fairfax, Virginia, a short drive from the United States Patent and Trademark Office (USPTO), Washington Dulles International Airport and Ronald Reagan National Airport.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About


